import git from "../generatedGitInfo.json";

export const GIT_STRING = `${git?.year}.${git?.month}.${git?.day}.${git?.count}:${git?.hash}`;
